<template>
    <div style="">
        <div @click="test" v-if="isShowOptionBtn" style="display: flex; position: fixed; z-index: 10; right: 0; align-items: center; gap: 20px; padding-right: 14px; padding-top: 16px; will-change: transform;" :style="{ top: $GlobalStore.statusBarHeight() + 'px' }">
            <div @click="showSearch">
                <img style="width: 20px;" :src="require('@/assets/img/search_gray2.png')" alt="">
            </div>
            <AlarmIcon></AlarmIcon>
        </div>
        <div @click="showOptionBtn" v-else-if="!isShowOptionBtn">
            <div style="display: flex; position: fixed; z-index: 10; gap: 4px; right: 0; align-items: center; padding-right: 10px; padding-top: 25px;" :style="{ top: $GlobalStore.statusBarHeight() + 'px' }">
                <div style="width: 6px; height: 6px; background-color: #210f03; border-radius: 50%;"></div>
                <div style="width: 6px; height: 6px; background-color: #210f03; border-radius: 50%;"></div>
                <div style="width: 6px; height: 6px; background-color: #210f03; border-radius: 50%;"></div>
            </div>
        </div>
    </div>
</template>

<script>
import AlarmIcon from '@/components/common/AlarmIcon'
import { PAGE_NAME } from '@/Constants';
    export default {
        name: 'OptionBtn',
        components: {AlarmIcon},
        props: {
            pageName: {
                type: String,
                default: ''
            },
            setIsShowTopBtn: {
                type: Function,
                default: () => {}
            }
        },
        mounted() {
            window.addEventListener('resize', this.handleResize);
            this.handleResize();
        },
        data() {
            return {
                fullWidth: 0,
                isShowOptionBtn: true,
                PAGE_NAME: PAGE_NAME
            }
        },
        methods: {
            showSearch() {
                console.log(this.pageName)
                if (this.pageName === PAGE_NAME.TRAINING) {
                    this.$Util.sendEventClick('축구배우기_검색아이콘_클릭', true)
                } else if (this.pageName === PAGE_NAME.SOCCER_TEAM) {
                    this.$Util.sendEventClick('축구팀입단_검색아이콘_클릭', true)
                }
                this.$GlobalStore.addModal('IntergrationSearch', { pageName: this.pageName })
            },
            test() {
                if (this.fullWidth >= 365) {
                    return
                }
                this.isShowOptionBtn = false
                this.setIsShowTopBtn(true)
            },
            handleResize() {
                this.fullWidth = window.innerWidth
                if (this.fullWidth < 365) {
                    this.isShowOptionBtn = false
                } else {
                    this.setIsShowTopBtn(true)
                    this.isShowOptionBtn = true
                }
            },
            showOptionBtn() {
                this.setIsShowTopBtn(false)
                this.isShowOptionBtn = true
            }
        }
    }
</script>

<styles scoped>

</styles>